
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
// Import version for cache-busting
import packageJson from './package.json';

// Helper to get browser language or fallback
const getInitialLanguage = () => {
  const saved = localStorage.getItem('deskbay_lang');
  if (saved) return saved;

  const browserLang = navigator.language.split('-')[0].toLowerCase();
  const supported = ['it', 'en', 'es', 'fr', 'de'];
  return supported.includes(browserLang) ? browserLang : 'en';
};

i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: false,

    backend: {
      // Load translations with version for cache-busting
      // This ensures new deployments fetch fresh translations
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${packageJson.version}`,
    },

    interpolation: {
      escapeValue: false, // React already handles XSS
    },

    react: {
      useSuspense: true, // Enable suspense for async loading
    },
  });

export default i18next;
